import { LoadingFile } from 'shared_DEPRECATED/components/File';

import { SessionRecapAttachmentType } from 'features/sessions/config/types';
import { useAttachmentsUpload } from 'features/sessions/hooks/useAttachmentsUpload';

type SessionRecapUnUploadedAttachmentsProps = {
  attachments: SessionRecapAttachmentType[];
  onSuccess?: (attachments: SessionRecapAttachmentType[]) => void;
  onError?: () => void;
};

export const SessionRecapUnUploadedAttachments = ({
  attachments = [],
  onSuccess,
  onError,
}: SessionRecapUnUploadedAttachmentsProps) => {
  useAttachmentsUpload({
    attachments,
    onSuccess,
    onError,
  });
  return (
    <>
      {attachments.map((attachment) => (
        <LoadingFile
          key={attachment.name}
          name={attachment.name}
          contentType={attachment.contentType}
        />
      ))}
    </>
  );
};
